import '../menu/menu.scss';

import React from 'react';

import Card from 'components/card';

export default (props) => {
	return (
		<ul className="menu">
			<li className="menu-item">
				<a href="#">{props.title}</a>
			</li>
			<li className="menu-item">
				<Card arrow="ne">{props.children}</Card>
			</li>
		</ul>
	);
};



/** WEBPACK FOOTER **
 ** ./components/dropdown/index.js
 **/